import React from 'react';
import { CheckCircle2Icon, ChevronRightIcon, LockKeyholeIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const plans = [{
  emoji: '📘',
  name: 'MÉTODO PÁDEL',
  tagline: 'El sistema completo para ordenar tus clases.',
  items: ['6 Tomos del Método', '5 Bonos de regalo', 'Acceso inmediato', 'Garantía 7 días'],
  oldPrice: '$89.000',
  price: '$23.990',
  href: 'https://stock.stockdigital.shop/checkout',
  cta: 'QUIERO EL MÉTODO PÁDEL',
  featured: false
}, {
  emoji: '🏆',
  name: 'MÉTODO PÁDEL DEFINITIVO',
  tagline: 'Todo el método + los recursos para la pista.',
  items: ['Método Pádel con sus tomos y bonos', 'Ejercicios listos para usar', 'Imágenes explicativas de golpes', 'Acceso inmediato + garantía 7 días'],
  oldPrice: '$129.000',
  price: '$35.990',
  href: 'https://metodopaddle.impultienda.ar/checkout/mega-pack-paddle-definitivo',
  cta: 'QUIERO EL PACK DEFINITIVO',
  featured: true
}];
export function PilatesPricing() {
  return <section id="pricing" className="bg-padel-surface px-4 py-16 sm:py-24" data-id="element-236" data-mp="qunu20yu1awv">
      <div className="mx-auto max-w-5xl" data-id="element-237" data-mp="vutotq0efdj6">
        <FadeIn data-id="element-238" data-mp="vtr0npugnp6y">
          <div className="text-center" data-id="element-239" data-mp="vt8ua0e33ulb">
            <p className="font-bold tracking-widest text-padel-lime" data-id="element-240" data-mp="10td8tkvfmf8w">
              ⏰ PRECIO DE LANZAMIENTO — DISPONIBLE POR TIEMPO LIMITADO
            </p>
            <h2 className="mt-3 font-display text-4xl font-black text-white" data-id="element-241" data-mp="14uymh8fsixk5">
              ELEGÍ TU PACK
            </h2>
          </div>
        </FadeIn>

        <div className="mt-12 grid items-start gap-6 lg:grid-cols-2" data-id="element-242" data-mp="1ekrujzgq4ujn">
          {plans.map((plan, i) => <FadeIn key={plan.name} delay={i * 0.1} data-id="element-243" data-mp="1jj34ea70r51v" data-mpi={i}>
              <article className={`relative flex h-full flex-col rounded-3xl border-2 bg-padel-dark p-8 ${plan.featured ? 'border-padel-lime shadow-[0_0_35px_rgba(197,255,61,.16)]' : 'border-padel-muted'}`} data-id="element-244" data-mp="1jlz340qoxxrd">
                {plan.featured && <span className="absolute -top-3 left-8 rounded-full bg-padel-lime px-3 py-1 text-xs font-black uppercase tracking-wider text-padel-dark" data-id="element-245" data-mp="3knnghgse9ptr">
                    Más completo
                  </span>}

                <p className="text-3xl" data-id="element-246" data-mp="3tkxtb6kv1n0s">{plan.emoji}</p>
                <h3 className="mt-4 font-display text-2xl font-black text-white sm:text-3xl" data-id="element-247" data-mp="c5hliyrikm4e">
                  {plan.name}
                </h3>
                <p className="mt-2 text-sm text-gray-400" data-id="element-248" data-mp="79k7x07mxtvb">{plan.tagline}</p>

                <div className="my-7 space-y-3" data-id="element-249" data-mp="l6p8ikoky0j6">
                  {plan.items.map(item => <p key={item} className="flex gap-2 text-gray-200" data-id="element-250" data-mp="h658n9cmgitc">
                      <CheckCircle2Icon className="h-5 w-5 shrink-0 text-padel-lime" data-id="element-251" data-mp="2mxtzdeioux2g" />
                      {item}
                    </p>)}
                </div>

                <div className="mt-auto" data-id="element-252" data-mp="28sjtnm87hr34">
                  <p className="text-lg text-gray-500 line-through" data-id="element-253" data-mp="28tlgenyl420o">
                    {plan.oldPrice}
                  </p>
                  <p className={`font-display text-5xl font-black ${plan.featured ? 'text-padel-lime' : 'text-white'}`} data-id="element-254" data-mp="2cwhuc1d6j9ya">
                    {plan.price}{' '}
                    <span className="font-sans text-xl font-normal text-gray-400" data-id="element-255" data-mp="1p4t5iuzkh3m3">
                      ARS
                    </span>
                  </p>

                  <a href={plan.href} target="_blank" rel="noopener noreferrer" className={`mt-6 flex w-full items-center justify-center gap-2 rounded-xl px-5 py-5 font-display text-lg font-black transition-transform hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark sm:text-xl ${plan.featured ? 'bg-padel-lime text-padel-dark' : 'border border-padel-lime bg-transparent text-padel-lime hover:bg-padel-lime hover:text-padel-dark'}`} data-id="element-256" data-mp="1u1t3sjq6d22n">
                    {plan.cta} <ChevronRightIcon className="h-6 w-6" data-id="element-257" data-mp="11eg6cqvvxnmn" />
                  </a>
                </div>
              </article>
            </FadeIn>)}
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-semibold text-gray-400" data-id="element-258" data-mp="rpy7wgb2vsm6">
          <span className="inline-flex gap-2" data-id="element-259" data-mp="mptreqa66xvy">
            <LockKeyholeIcon className="h-4 w-4 text-padel-lime" data-id="element-260" data-mp="moimuo8whm3s" />
            Pago 100% seguro
          </span>
          <span className="inline-flex gap-2" data-id="element-261" data-mp="hpnvuz0s4r8l">
            <ZapIcon className="h-4 w-4 text-padel-lime" data-id="element-262" data-mp="dovj3vsp847k" />
            Acceso en 5 minutos
          </span>
          <span className="inline-flex gap-2" data-id="element-263" data-mp="8s54ze0gfios">
            <ShieldCheckIcon className="h-4 w-4 text-padel-lime" data-id="element-264" data-mp="2ke5yamb8sj2s" />
            Garantía 7 días
          </span>
          <span className="inline-flex gap-2" data-id="element-265" data-mp="2pd0dzfdwxrio">
            <CreditCardIcon className="h-4 w-4 text-padel-lime" data-id="element-266" data-mp="2pbpazhsaknsm" />
            Mercado Pago — Tarjeta — Transferencia
          </span>
        </div>
      </div>
    </section>;
}